import { Link } from "react-router-dom";
import {
  ChefHat,
  Home,
  Flame,
  Users,
} from "lucide-react";
import styles from "./ExpertCulinaryCategories.module.css";

const CATEGORIES = [
  {
    title: "Professional Chefs",
    description:
      "Specialized talents for high-volume commercial kitchens and fine dining excellence.",
    path: "/cooks/chef",
    icon: ChefHat,
  },
  {
    title: "House Cooks",
    description:
      "Reliable daily support for households with diverse regional cuisine and health needs.",
    path: "/cooks/housecook",
    icon: Home,
  },
  {
    title: "Party Cooks",
    description:
      "Expert occasion chefs to elevate your house parties and private boutique gatherings.",
    path: "/cooks/partycook",
    icon: Flame,
  },
  {
    title: "Catering Teams",
    description:
      "Full culinary crews ready to scale for large events, weddings, and corporate summits.",
    path: "/cooks/catering",
    icon: Users,
  },
];

export default function ExpertCulinaryCategories() {
  return (
    <section className={styles.section} aria-labelledby="expert-categories-title">
      <div className={styles.headerRow}>
        <div>
          <h2 id="expert-categories-title" className={styles.title}>
            Expert Culinary Categories
          </h2>
          <p className={styles.subtitle}>
            Specialized talent pools curated for every professional kitchen and
            household requirement.
          </p>
        </div>
      </div>

      <div className={styles.grid}>
        {CATEGORIES.map(({ title, description, path, icon: Icon }) => (
          <Link key={title} to={path} className={styles.categoryCard}>
            <span className={styles.iconWrap} aria-hidden>
              <Icon size={22} strokeWidth={1.75} />
            </span>
            <h3 className={styles.cardTitle}>{title}</h3>
            <p className={styles.cardText}>{description}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
